import styled from 'styled-components';

import { Screen, screenBiggerThan } from '@client/styles/styled-components/breakpoints';

const getContainerHeight = ({
    isCampaignTitleExperiment,
    isHideCgExperiment,
}: {
    isCampaignTitleExperiment: boolean;
    isHideCgExperiment: boolean;
}) => {
    if (isHideCgExperiment) {
        return isCampaignTitleExperiment ? '90px' : '70px';
    }

    return isCampaignTitleExperiment ? '112px' : '99px';
};

export const Container = styled.div<{
    isCampaignTitleExperiment: boolean;
    isHideCgExperiment: boolean;
}>`
    position: relative;
    min-height: 60px;
    background-color: ${({ theme }) => theme.functionColor.function0};
    color: ${({ theme }) => theme.functionColor.function100};
    text-align: center;
    display: flex;
    align-items: normal;

    ${screenBiggerThan(Screen.mobile)} {
        height: ${({ isCampaignTitleExperiment, isHideCgExperiment }) =>
            getContainerHeight({ isCampaignTitleExperiment, isHideCgExperiment })};
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    font-size: 1.3rem;
`;

export const RegularContainer = styled.div<{ isCampaignTitleExperiment: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 15px 15px 0 15px;

    ${screenBiggerThan(Screen.mobile)} {
        padding: ${prop => (prop.isCampaignTitleExperiment ? '8px 12px' : '12px 12px 0 12px')};
        justify-content: space-between;
    }
`;

export const RegularTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 9px 0;

    ${screenBiggerThan(Screen.mobile)} {
        padding: 0;
    }
`;

export const InfoWrapper = styled.div<{ isHideCgExperiment: boolean }>`
    display: flex;
    flex-direction: column;
    margin-bottom: ${props => (props.isHideCgExperiment ? '4px' : null)};
`;

export const Title = styled.div<{ isCampaignTitleExperiment: boolean }>`
    width: 100%;
    background: ${({ theme }) => theme.functionColor.function0};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    font-size: 1.4rem;
    line-height: 1.4;
    font-weight: 700;
    flex: 1 1 auto;
    color: ${({ theme }) => theme.functionColor.function100};
    text-align: start;
    overflow: hidden;

    ${screenBiggerThan(Screen.mobile)} {
        display: ${prop => (prop.isCampaignTitleExperiment ? '-webkit-box' : 'none')};
        -webkit-line-clamp: 1;
    }
`;
